export const APIType = {
   POST: 'POST',
   GET: 'GET',
   PUT: 'PUT',
   DELETE: 'DELETE',
} as const;
